import { createApp, defineAsyncComponent } from 'vue'
import { createPinia } from 'pinia'

if (document.getElementById('quizWrapper')) {
    const pinia = createPinia()

    createApp({})
        .component(
            'gp-quiz',
            defineAsyncComponent(() => import('./components/Quiz/QuizComponent.vue'))
        )
        .use(pinia)
        .mount('#quizWrapper')
}

if (document.getElementById('questionnaireWrapper')) {
    const pinia = createPinia()

    createApp({})
        .use(pinia)
        .component(
            'gp-questionnaire',
            defineAsyncComponent(
                () => import('./components/Questionnaire/QuestionnaireComponent.vue')
            )
        )
        .mount('#questionnaireWrapper')
}

if (document.getElementById('surveyWrapper')) {
    const pinia = createPinia()

    createApp({})
        .use(pinia)
        .component(
            'gp-survey',
            defineAsyncComponent(() => import('./components/Survey/SurveyComponent.vue'))
        )
        .mount('#surveyWrapper')
}

if (document.getElementById('vue')) {
    createApp({})
        .component(
            'preferred-languages',
            defineAsyncComponent(
                () => import('@/components/PreferredLanguages/PreferredLanguages.vue')
            )
        )
        .component(
            'gp-countdown',
            defineAsyncComponent(() => import('@/components/Countdown.vue'))
        )
        .component(
            'gp-animated-number',
            defineAsyncComponent(() => import('@/components/AnimatedNumber/AnimatedNumber.vue'))
        )
        .mount('#vue')
}

if (document.getElementById('battleChallengersSearch')) {
    createApp({})
        .component(
            'gp-battle-challengers-search',
            defineAsyncComponent(
                () => import('./components/BattleChallengersSearch/BattleChallengersSearch.vue')
            )
        )
        .mount('#battleChallengersSearch')
}

if (document.getElementById('previewModuleWrapper')) {
    createApp({})
        .component(
            'gp-module-preview',
            defineAsyncComponent(() => import('./components/ModulePreview/ModulePreview.vue'))
        )
        .mount('#previewModuleWrapper')
}
